import { render, staticRenderFns } from "./TablePopover.vue?vue&type=template&id=0fec2148&"
import script from "./TablePopover.vue?vue&type=script&lang=ts&"
export * from "./TablePopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports